module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Sertus","short_name":"Sertus","start_url":"/","background_color":"#ffffff","theme_color":"#363636","display":"standalone","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"571e05f42d81f7dfa6ca02fdecefaa88"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
